import React, { useState, useEffect, useRef } from "react";
import { ClickAwayListener, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import html2canvas from "html2canvas";
import axios1 from "axios";

import { GetStateFromData } from "../../../CustomHooks/CustomHooks";
import axios from "../../../../axios.js";
import CustomizedAlert from "../../../../ReusableComponents/Alert/CustomizedAlert";
import SaveTemplate from "./SaveTemplate";
import { add_template } from "../../../constant";
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from "../../../../utils/secureSessionStorage.js";

const useStyles = makeStyles(() => ({
  container: {
    position: "relative"
  },
  saveDropDown: {
    position: "absolute",
    width: "200px",
    overflow: "unset",
    display: "none",
    flexDirection: "column",
    top: "2.2em",
    left: "-14.2em",
    boxShadow: "0px 0px 6px #00000029",
    borderRadius: "2px",
    lineHeight: "36px",
    textAlign: "start",
    zIndex: "999999",
    background: "#fff",
    color: "#000",

    "&:focus": {
      width: "200px",
      overflow: "unset"
    },

    "& span": {
      height: "36px",
      padding: "0 10px",

      "&:hover": {
        background: "#d6eeff"
      }
    },

    "& span:focus": {
      width: "200px",
      overflow: "unset"
    }
  }
}));

const MoreSaveOptions = ({ applicationData, openPopupSave, setOpenPopupSave, ...props }) => {
  const contexts = GetStateFromData(props.containerId);

  const { activeSubForm, activePage, formState2 } = contexts.contexts;
  const activityStream = window.activityStream ? window.activityStream : () => {};

  const classes = useStyles();
  const { t } = useTranslation(["styles", "translation"]);
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  var emptyTemplate = {
    templatename: "",
    description: "",
    templatetype: "USER DEFINED",
    templateimage: "",
    templatecategory: "TEMPLATE",
    templatebuffer: applicationData.applicationId?.toString(),
    categoryid: 0,
    categoryname: null,
    tablestatus: null
  };

  const [newTemplate, setNewTemplate] = useState(emptyTemplate);
  const [saveAppTemplate_popup, setSaveAppTemplate_popup] = useState("closed");
  const [savePageTemplate_popup, setSavePageTemplate_popup] = useState("closed");
  const [saveSubformTemplate_popup, setSaveSubformTemplate_popup] = useState("closed");
  const [user, setUser] = useState();
  const [screenshot, setScreenshot] = useState();
  const [allTemplateCategories, setAllTemplateCategories] = useState([]);
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification"
  });
  const [isSubformAttached, setIsSubformAttached] = useState(false)

  const checkSubformInWizard = (wizardChild) => {
    for(let child of wizardChild){
      if(child?.subformName){
        return true
      }
      if(Array.isArray(child?.children) && child?.children?.length > 0){
        if(checkSubformInWizard(child.children)){
          return true
        }
      }
    }
    return false
  }

  const isSubFormAttachedInWizard = (formJSON) => {
    if(formJSON?.containerControl?.includes("wizard")){
      return checkSubformInWizard(formJSON?.children?.[1]?.children?.[1]?.children)
    }
  }


  useEffect(() => {
    if(openPopupSave){
      const isSubformAtt = isSubFormAttachedInWizard(formState2)
      setIsSubformAttached(isSubformAtt)
    }
  }, [openPopupSave])

  const getTemplateCategories = () => {
    axios
      .get("/categories/category/TEMPLATE", { withCredentials: true })
      .then((res) => {
        setAllTemplateCategories(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getDetails = () => {
    const launchpadKey =
      secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;

    axios1
      .get(
        `/formBuilder/idesign/getTokenData`,
        { headers: { Authorization: `Bearer ${launchpadKey || undefined}` } },
        { withCredentials: true }
      )
      .then((res) => {
        const sessionData = res.data?.value;
        setUser(sessionData?.sessionData?.userId);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getTemplateCategories();
    getDetails();
  }, []);

  function createNewAppTemplate(type, templateDetails) {
    setNewTemplate({ ...newTemplate, tablestatus: 0 });
    let newTemplateVar = { ...newTemplate, tablestatus: 0 };
    let dateNow = new Date();

    newTemplateVar["templatename"] = templateDetails.templateName;
    newTemplateVar["categoryid"] = type === "app" ? templateDetails?.categoryid : undefined;
    newTemplateVar["categoryname"] = type === "app" ? templateDetails.categoryName : templateDetails.templateCategory;
    newTemplateVar["description"] = templateDetails.templateDesciption;
    newTemplateVar["createddatetime"] = dateNow;
    newTemplateVar["createdby"] = user;
    newTemplateVar["lastAccessedby"] = user;
    newTemplateVar["lastModifiedtime"] = dateNow;
    newTemplateVar["usageCount"] = 0;
    newTemplateVar["lastAccessedtime"] = dateNow;
    newTemplateVar["lastModifiedby"] = user;
    newTemplateVar["templatecategory"] = "TEMPLATE";

    if (type && type === "app" && applicationData?.formPageType === "Processes") {
      newTemplateVar["activeFormPageType"] = applicationData.formPageType;
      newTemplateVar["activeStatusType"] = applicationData.statusType;
      newTemplateVar["activeIdentifierId"] = applicationData?.processId?.toString();
      newTemplateVar["templatebuffer"] =
        applicationData?.formDefId !== undefined ? applicationData?.formDefId?.toString() : window.formBuffer;
    } else if (
      type &&
      type === "app" &&
      applicationData?.formPageType === "Portals" &&
      applicationData.fragmentId === undefined
    ) {
      newTemplateVar["activeFormPageType"] = applicationData.formPageType;
      newTemplateVar["activeStatusType"] = applicationData.statusType;
      newTemplateVar["activeIdentifierId"] = applicationData?.processId?.toString();
      newTemplateVar["templatebuffer"] =
        applicationData?.formDefId !== undefined ? applicationData?.formDefId?.toString() : window.formBuffer;
    } else if (
      type &&
      type === "app" &&
      applicationData?.formPageType === "Portals" &&
      applicationData.fragmentId !== undefined
    ) {
      newTemplateVar["activeFormPageType"] = applicationData.formPageType;
      newTemplateVar["activeStatusType"] = "R";
      newTemplateVar["activeIdentifierId"] = applicationData?.processId?.toString();
      newTemplateVar["templatebuffer"] =
        applicationData?.fragmentId !== undefined ? applicationData?.fragmentId?.toString() : window.formBuffer;
    } else if (type && type === "app") {
      newTemplateVar["activeFormPageType"] = "Applications";
      newTemplateVar["activeStatusType"] = "A";
      newTemplateVar["activeIdentifierId"] = applicationData?.defaultFormId?.toString();
      newTemplateVar["templatebuffer"] =
        applicationData?.applicationId !== undefined ? applicationData?.applicationId?.toString() : window.formBuffer;
    }

    axios
      .post("/templates/", newTemplateVar, {
        withCredentials: true,
        headers: {
          templateInfo: `${applicationData?.applicationName}#${window?.currentWidget?.fragmentName}`
        }
      })
      .then((res) => {
        setAlertData({
          open: true,
          type: "save",
          alertType: "success",
          showConfirm: "showNotification",
          alertContentMsg: `${t("Saved_App_template")}`
        });
        const object = {
          artifactType: "Templates",
          id: res.data.templateid.toString(),
          name: res.data.templatename
        };

        activityStream(object, add_template, "create", "ifd_0015");

        setNewTemplate({
          templatename: "",
          description: "",
          templatetype: "USER DEFINED",
          templateimage: "",
          templatecategory: "TEMPLATE",
          templatebuffer:
            applicationData?.applicationId !== undefined
              ? applicationData?.applicationId?.toString()
              : window.formBuffer,
          categoryid: 0,
          tablestatus: null
        });
        setSaveAppTemplate_popup("closed");
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 400) {
            // setShowLoader(false);
            if (err.response.data.error === "201") {
              setAlertData({
                open: true,
                alertType: "error",
                showConfirm: "showNotification",
                alertContentMsg: `${t("Template_Name_Is_Empty")}`
              });
            } else if (err.response.data.error === "202") {
              setAlertData({
                open: true,
                alertType: "error",
                showConfirm: "showNotification",
                alertContentMsg: `${t("Template_Name_Already_Exists")}`
              });
            }
            setSaveAppTemplate_popup("open");
          } else {
            console.log("Error :: ", err);
            setAlertData({
              open: true,
              alertType: "error",
              showConfirm: "showNotification",
              alertContentMsg: "Template failed with 500 error!"
            });
            setSaveAppTemplate_popup("open");
          }
        }
      });
  }

  function createNewSubformTemplate(templateDetails) {
    setNewTemplate({ ...newTemplate, tablestatus: 0 });
    let newTemplateVar = {
      ...newTemplate,
      tablestatus: 0,
      templatecategory: "FORM"
    };
    let dateNow = new Date();
    newTemplateVar["categoryid"] = templateDetails?.categoryid;
    newTemplateVar["templatename"] = templateDetails.templateName;
    newTemplateVar["categoryname"] = templateDetails.templateCategory;
    newTemplateVar["description"] = templateDetails.templateDesciption;
    newTemplateVar["createddatetime"] = dateNow;
    newTemplateVar["createdby"] = user;
    newTemplateVar["lastAccessedby"] = user;
    newTemplateVar["lastModifiedtime"] = dateNow;
    newTemplateVar["usageCount"] = 0;
    newTemplateVar["lastAccessedtime"] = dateNow;
    newTemplateVar["lastModifiedby"] = user;
    newTemplateVar["templatecategory"] = "FORM";
    axios
      .post("/templates/", newTemplateVar, {
        withCredentials: true,
        headers: {
          templateInfo: `${applicationData?.applicationName}#${
            window.activeApplication?.selectedSubform?.fragmentName || window.formBuffer?.formName
          }`
        }
      })
      .then((res) => {
        setAlertData({
          open: true,
          alertType: "success",
          type: "save",
          showConfirm: "showNotification",
          alertContentMsg: "Saved as Subform template."
        });

        setNewTemplate({
          templatename: "",
          description: "",
          templatetype: "USER DEFINED",
          templateimage: "",
          templatecategory: "FORM",
          templatebuffer: JSON.stringify(window.formBuffer),
          categoryid: -3,
          categoryname: null,
          tablestatus: null
        });
        const object = {
          artifactType: "Templates",
          id: res.data.templateid.toString(),
          name: res.data.templatename
        };
        activityStream(object, add_template, "create", "ifd_0015");
        setSaveSubformTemplate_popup("closed");
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 400) {
            // setShowLoader(false);
            if (err.response.data.error === "201") {
              setAlertData({
                open: true,
                alertType: "error",
                showConfirm: "showNotification",
                alertContentMsg: `${t("Template_Name_Is_Empty")}`
              });
            } else if (err.response.data.error === "202") {
              setAlertData({
                open: true,
                alertType: "error",
                showConfirm: "showNotification",
                alertContentMsg: `${t("Template_Name_Already_Exists")}`
              });
            }
            setSaveAppTemplate_popup("open");
          } else {
            console.log("Error :: ", err);
            setAlertData({
              open: true,
              alertType: "error",
              showConfirm: "showNotification",
              alertContentMsg: "Template failed with 500 error!"
            });
            setSaveAppTemplate_popup("open");
          }
        }
      });
  }

  function createNewPageTemplate(formBuffer, templateDetails) {
    setNewTemplate({ ...newTemplate, tablestatus: 0 });
    let newTemplateVar = { ...newTemplate, tablestatus: 0 };
    let dateNow = new Date();
    newTemplateVar["categoryid"] = templateDetails?.categoryid;
    newTemplateVar["templatename"] = templateDetails.templateName;
    newTemplateVar["categoryname"] = templateDetails.templateCategory;
    newTemplateVar["description"] = templateDetails.templateDesciption;
    newTemplateVar["createddatetime"] = dateNow;
    newTemplateVar["createdby"] = user;
    newTemplateVar["lastAccessedby"] = user;
    newTemplateVar["lastModifiedtime"] = dateNow;
    newTemplateVar["usageCount"] = 0;
    newTemplateVar["lastAccessedtime"] = dateNow;
    newTemplateVar["lastModifiedby"] = user;
    newTemplateVar["templatecategory"] = "PAGE";
    newTemplateVar["templatebuffer"] = formBuffer;
    newTemplateVar["templateimage"] = screenshot;
    axios
      .post("/templates/", newTemplateVar, {
        withCredentials: true,
        headers: {
          templateInfo: `${applicationData?.applicationName}#${window?.currentInterface?.formName}`
        }
      })
      .then((res) => {
        setAlertData({
          open: true,
          alertType: "success",
          type: "save",
          showConfirm: "showNotification",
          alertContentMsg: `${t("Saved_Page_template")}`
        });

        setNewTemplate({
          templatename: "",
          description: "",
          templatetype: "USER DEFINED",
          templateimage: "",
          templatecategory: "PAGE",
          templatebuffer: JSON.stringify(window.formBuffer),
          categoryid: -3,
          categoryname: null,
          tablestatus: null
        });
        const object = {
          artifactType: "Templates",
          id: res.data.templateid.toString(),
          name: res.data.templatename
        };
        activityStream(object, add_template, "create", "ifd_0015");
        setSavePageTemplate_popup("closed");
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 400) {
            // setShowLoader(false);
            if (err.response.data.error === "201") {
              setAlertData({
                open: true,
                alertType: "error",
                showConfirm: "showNotification",
                alertContentMsg: `${t("Template_Name_Is_Empty")}`
              });
            } else if (err.response.data.error === "202") {
              setAlertData({
                open: true,
                alertType: "error",
                showConfirm: "showNotification",
                alertContentMsg: `${t("Template_Name_Already_Exists")}`
              });
            }
            setSaveAppTemplate_popup("open");
          } else if (err?.response?.data?.error === "899") {
            setAlertData({
              open: true,
              alertType: "error",
              showConfirm: "showNotification",
              alertContentMsg: `${t("temp_count_limit")}`,
            });
          } 
          else {
            console.log("Error :: ", err);
            setAlertData({
              open: true,
              alertType: "error",
              showConfirm: "showNotification",
              alertContentMsg: "Template failed with 500 error!"
            });
            setSaveAppTemplate_popup("open");
          }
        }
      });
  }

  const saveAsAppTemplate = async (e) => {
    setOpenPopupSave(false);
    document.activeElement.blur();
    e.stopPropagation();
    setSaveAppTemplate_popup("open");
  };

  const saveAsPageTemplate = async (e) => {
    try {
      setOpenPopupSave(false);
      document.activeElement.blur();
      e.stopPropagation();
      html2canvas(document.getElementById("mainCanvas"), {
        allowTaint: true,
        useCORS: true
      })
        .then(function (canvas) {
          let image = canvas.toDataURL("image/png", 0.5);
          props.setScreenshot(image);
        })
        .catch((e) => {
          console.log(e);
        });
      setSavePageTemplate_popup("open");
    } catch (error) {
      console.log("Error :: ", error);
    }
  };

  const saveAsSubformTemplate = async (e) => {
    try {
      setOpenPopupSave(false);
      document.activeElement.blur();
      e.stopPropagation();
      setSaveSubformTemplate_popup("open");
    } catch (error) {
      console.log("Error :: ", error);
    }
  };

  function onClickAway(e){
    let elem = document.getElementById("pageTemplate_FocusableDiv")?.contains(e.target)
    console.info(elem, "elem")
    setOpenPopupSave(false)
  }

//   function listenToclicks(e) {
//     if (openPopupSave) {
//       const targetFound = e.target.closest("#pageTemplate_FocusableDiv");
//       if (!targetFound) {
//         setOpenPopupSave(false);
//       }
//     }
//   }

//   useEffect(() => {
//     if (openPopupSave) {
//       window.addEventListener("keydown", listenToKeyDown);
//       window.addEventListener("click", listenToclicks);

//       return () => {
//         window.removeEventListener("keydown", listenToKeyDown);
//         window.removeEventListener("click", listenToclicks);
//       };
//     }
//   }, [openPopupSave]);

const ref = useRef(null);

useEffect(() => {
  function handleClickOutside(e) {
    if (openPopupSave && ref.current && !ref.current.contains(e.target)) {
      setOpenPopupSave(false);
    }
  }

  function handleKeyDown(e) {
    if (openPopupSave && e.key === "Escape") {
      setOpenPopupSave(false);
    }
  }

  if (openPopupSave) {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("keydown", handleKeyDown);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [openPopupSave]);

  return (
    <>
      <div className={classes.container} onClick={(e) => e.stopPropagation()}>
        <ClickAwayListener onClickAway={(evt) => onClickAway(evt)}>
          <div
            id="pageTemplate_FocusableDiv"
            ref={ref}
            className={classes.saveDropDown}
            style={
              translationStyles1
                ? {
                    left: "unset",
                    right: "-10em",
                    display: openPopupSave ? "flex" : "none"
                  }
                : {
                    display: openPopupSave ? "flex" : "none"
                  }
            }
          >
            <span
              tabIndex="0"
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") {
                  saveAsPageTemplate(e);
                } else if (e.key === "Escape" || e.key === "Esc") {
                  setOpenPopupSave(false);
                } else if (e.shiftKey === true && e.key === "Tab") {
                  setOpenPopupSave(false);
                }
              }}
              onClick={(e) => saveAsPageTemplate(e)}
              className={
                (activePage && activePage !== undefined && activePage !== false && !isSubformAttached)
                  ? "activeBtn"
                  : "inactiveBtn"
              }
            >
              {t("Save Page as Template")}
            </span>

            <span
              tabIndex="0"
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") {
                  saveAsSubformTemplate(e);
                } else if (e.key === "Escape" || e.key === "Esc") {
                  setOpenPopupSave(false);
                }
              }}
              onClick={(e) => saveAsSubformTemplate(e)}
              className={activeSubForm && activeSubForm !== undefined && activeSubForm !== false ? "activeBtn" : "inactiveBtn"}
            >
              {t("Save Subform as Template")}
            </span>

            <span
              tabIndex="0"
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") {
                  saveAsAppTemplate(e);
                } else if (e.key === "Escape" || e.key === "Esc") {
                  setOpenPopupSave(false);
                } else if (!e.shiftKey && e.key === "Tab") {
                  setOpenPopupSave(false);
                }
              }}
              onClick={(e) => saveAsAppTemplate(e)}
              className={((activePage && activePage !== undefined && activePage !== false) || applicationData?.formDefId) ? "activeBtn" : "inactiveBtn"}
            >
              {t("Save Application as Template")}
            </span>
          </div>
        </ClickAwayListener>
        {saveAppTemplate_popup === "open" && (
          <SaveTemplate
            applicationData={applicationData}
            templateType={"app"}
            screenshot={screenshot}
            createNewTemplate={createNewAppTemplate}
            setSaveAppTemplate_popup={setSaveAppTemplate_popup}
            setNewTemplate={setNewTemplate}
            newTemplate={newTemplate}
            allCategories={allTemplateCategories}
            activityStream={activityStream}
            formBuffer={formState2}
          />
        )}

        {savePageTemplate_popup === "open" && (
          <SaveTemplate
            applicationData={applicationData}
            templateType={"page"}
            screenshot={screenshot}
            createNewTemplate={createNewPageTemplate}
            setSavePageTemplate_popup={setSavePageTemplate_popup}
            setNewTemplate={setNewTemplate}
            newTemplate={newTemplate}
            allCategories={allTemplateCategories}
            activityStream={activityStream}
            formBuffer={formState2}
          />
        )}

        {saveSubformTemplate_popup === "open" && (
          <SaveTemplate
            applicationData={applicationData}
            templateType={"form"}
            screenshot={screenshot}
            setScreenshot={setScreenshot}
            createNewTemplate={createNewSubformTemplate}
            setSaveSubformTemplate_popup={setSaveSubformTemplate_popup}
            setNewTemplate={setNewTemplate}
            newTemplate={newTemplate}
            allCategories={allTemplateCategories}
            activeSubForm={activeSubForm}
            activityStream={activityStream}
            formBuffer={formState2}
          />
        )}
      </div>
      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    </>
  );
};

export default MoreSaveOptions;
